import * as yup from "yup";

export const ROESetupValidationSchema = yup.object({
  startDate: yup
    .date()
    .typeError("Invalid date format") // Ensures the input is a valid date
    .required("Start date is required"),
  endDate: yup
    .date()
    .typeError("Invalid date format") // Ensures the input is a valid date
    .required("End date is required"),
  serialNoOfRoeAmendedOrReplaced: yup
    .string()
    .min(9, "Serial No has at most 9 characters")
    .required("Serial No is required"),

  // employerPayrollReferenceNo: yup
  //   .string()
  //   .max(26, "Employer Payroll Reference No has at most 26 characters"),
  occupation: yup
    .string()
    .max(40, "Occupation has at most 40 characters")
    .required("Occupation is required"),

  // expectedDateOfRecallDate: yup
  //   .date()
  //   .nullable()
  //   .test(
  //     "expectedDateOfRecallDate-required",
  //     "Date is required",
  //     function (value) {
  //       const { expectedDateOfRecall } = this.parent;

  //       // If expectedDateOfRecall === 100 → date must be provided
  //       if (expectedDateOfRecall === "100") {
  //         return value != null; // date required
  //       }

  //       // Otherwise → date not required
  //       return true;
  //     }
  //   )
  //   .required("expected Date Of Recall is required"),
  expectedDateOfRecallDate: yup
    .date()
    .nullable()
    .typeError("Invalid date format")
    .test(
      "expectedDateOfRecallDate-required",
      "Date is required",
      function (value) {
        const { expectedDateOfRecall } = this.parent;

        // required only when expectedDateOfRecall === "100"
        if (expectedDateOfRecall === "100") {
          return value != null;
        }

        return true; // not required otherwise
      },
    ),
  // totalInsurableHoursAccordingToChart: yup
  //   .string()
  //   .required("Total insurable hours is required")
  //   .min(1, "Total insurable hours must be at least 1")
  //   .max(8904, "Total insurable hours cannot exceed 8,904"),
  reasonForIssuringThisRoe: yup
    .string()
    .required("Reason for Issuring This Roe is required"),
  contactPerson: yup.string().required("Contact Person is required"),
});
